import { render, staticRenderFns } from "./MetricIcon.vue?vue&type=template&id=780d44a7&scoped=true&"
import script from "./MetricIcon.vue?vue&type=script&lang=ts&"
export * from "./MetricIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "780d44a7",
  null
  
)

export default component.exports